import './style.scss';
import ViewSchool from "./viewSchool";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchDistricts, restoreCurrentDistrictFromLocalStorage} from "../../actions/districts";
import {fetchSchools, getSchoolDemographicInfo, getSchoolProfile} from "../../actions/schools";
import DemographicInfo from "./demographicInfo";
import {useSearchParams} from "react-router-dom";

export const route = 'school-profile';

const SchoolProfile = () => {
  const [profileEdit, setProfileEdit] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const errors = useSelector((state) => state.schools.schoolFormErrors);
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const atpCode = searchParams.get('atpCode');

  useEffect(() => {
    async function getDistrictAndSchools() {
      if (!currentDistrict && !schools) {
        await dispatch(restoreCurrentDistrictFromLocalStorage());
        await dispatch(fetchSchools(currentDistrict));
      }
    }

    getDistrictAndSchools();
  });

  const currentDistrict = useSelector((state) => state.districts.currentDistrict);

  const schools = useSelector((state) => state.schools.schools);

  const schoolProfile = (schools) ? schools.find((school) => school.atpCode === atpCode) : null;

  useEffect(() => {
    if (currentDistrict && schools && !demographicInfo) {
      dispatch(getSchoolDemographicInfo(atpCode))
    }
  })

  const demographicInfo = useSelector((state) => state.schools.schoolDemographicInfo);

  if (formSubmitted && !errors) {
    setFormSubmitted(false);
    setProfileEdit(false);
  }

  const districtHeader = () => {
    return (currentDistrict && schoolProfile) ? (
      <div className='school-profile-header'>
        <span className='school-header-district'>{currentDistrict.name}</span> / <span className='school-header-school'>{schoolProfile.name}</span>
      </div>) : '';
  }


  return (
    <div className='main-content'>
      {districtHeader()}
      <div className='school-profile-container'>
        <div className='school-info-content'>
          <ViewSchool schoolProfile={schoolProfile} district={currentDistrict}/>
        </div>
      </div>
      <div className='school-demographic-container'>
        <DemographicInfo demographicInfo={demographicInfo}/>
      </div>
    </div>
  );
}

export default SchoolProfile;